<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <div class="main-title">五粮液CRM系统</div>
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div v-if="mdmManager" class="avatar-wrapper">
          <img src="~@/assets/images/notice.png" class="user-avatar">
          <span @click="msgLogDialog = true">消息通知</span>
        </div>
        <!-- <notice class="right-menu-item hover-effect" /> -->
        <div class="avatar-wrapper">
          <img src="~@/assets/images/avatar@3x.png" class="user-avatar">
          <span>欢迎 {{ role.USER_NAME }}({{ role.USER_BP }})</span>
        </div>
        <div class="avatar-wrapper role-wrapper">
          <span>岗位:{{ role.positionName }}</span>
        </div>

        <!-- <el-dropdown>
          <span style="font-size: 12px; color: #fff; margin-right: 25px;">
            <i class="el-icon-s-tools" style="margin-right: 5px" />设置
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span @click.stop="changeRole">切换角色</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click.stop="editPass">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click.stop="logout">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <div class="exit-wrapper role-wrapper" @click="changeRole">
          <span>切换角色</span>
        </div>
        <div class="exit-wrapper" @click="logout">
          <img src="~@/assets/images/exit@3x.png" class="user-avatar">
          <span>退出</span>
        </div>
        <!-- <el-tooltip content="全局字体大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="请选择角色"
      :visible.sync="showDialog"
      width="50%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <template v-if="showDialog">
        <role-select ref="dialogSelect" v-loading="loading" @check="submitHandle" />
      </template>
    </el-dialog>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="修改密码"
      :visible.sync="showPassDialog"
      width="50%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <template v-if="showPassDialog">
        <modify-pass ref="ModifyPass" />
      </template>
      <div slot="footer">
        <el-button size="small" @click="showPassDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="msgLogDialog"
      title="消息列表"
      width="70%"
      destroy-on-close
    >
      <message-dialog />
    </el-dialog>

    

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
// import Notice from '@/components/Notice'
import { logout } from '@/api/login'
import { getToken, clearToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { apiFindUnreadMsg, apiUpdatePassword, apiFindSavedApplyBill } from '@/api/common'

const ModifyPass = () => import('@/components/dialog/ModifyPass.vue')
const RoleSelect = () => import('@/components/dialog/RoleSelect.vue')
const MessageDialog = () => import('@/components/dialog/MessageDialog')
export default {
  components: {
    Hamburger,
    RoleSelect,
    ModifyPass,
    MessageDialog
    // Notice
  },
  data() {
    return {
      showDialog: false,
      msgLogDialog: false,
      showPassDialog: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'userInfo', 'role', 'mdmManager'])
  },
  created() {
    this.msglen()
  },
  methods: {
    async msglen() {
      if (this.mdmManager) {
        // 获取消息列表，如果消息列表有未读消息则显示，没有则不现实
        const { data } = await apiFindUnreadMsg({ msgType: 'web' })
        this.msgLogDialog = !!data.Rows.length
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    editPass() {
      this.showPassDialog = true
    },
    async logout() {
      logout({
        data: getToken()
      }).then((res) => {
        clearToken()
        if (res.status === 1) {
          this.$store.commit('permission/RESET_ROUTES')
          this.$store.commit('permission/RESET_BUTTONS')
          this.$store.dispatch('permission/resetToken')
          this.$store.commit('user/SET_CHECKEROLE', 0)
          this.$store.commit('user/SET_SAPROLES', {})
          this.$router.replace('/login?authToken=crmToken')
          resetRouter()
        }
      })
      // await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    changeRole() {
      this.showDialog = true
    },
    async handleSubmit() {
      const data = await this.$refs.ModifyPass.sub()
      const formData = new FormData()
      formData.append('psw', data.psw)
      formData.append('newPsw', data.newPsw)
      const res = await apiUpdatePassword(formData)
      if (res.status === 1) {
        this.$message.success('密码修改成功！请重新登录！')
        this.logout()
      }
    },
    async submitHandle() {
      this.loading = true
      try {
        const data = await this.$refs.dialogSelect.submitForm()
        if (!data) return
        this.$store.commit('permission/RESET_ROUTES')
        resetRouter()
        let accessRoutes = null
        try {
          accessRoutes = await this.$store.dispatch('permission/generateRoutes')
        } catch (e) {
          // this.$message.error(e.message)
          this.showDialog = false
          this.loading = false
          return
        }

        this.$router.addRoutes(accessRoutes)
        this.showDialog = false
        this.loading = false
        this.$router.push({ path: '/' })
      } catch (error) {
        this.showDialog = false
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}

.navbar {
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  position: relative;
  height: 57px;
  background: #dc0617;

  .hamburger-container {
    line-height: 57px;
    height: 100%;
    cursor: pointer;
    transition: 0.3s;
    -webkit-tap-highlight-color: transparent;
    padding-left: 24px !important;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .main-title {
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    line-height: 57px;
  }

  .right-menu {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 57px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-wrapper {
      display: flex;
      align-items: center;
      font-weight: 400;
      color: #ffffff;
      font-size: 12px;
      margin-right: 14px;
      margin-left: 14px;
      .user-avatar {
        width: 25px;
        height: 25px;
        margin-right: 3px;
      }
      span {
        line-height: 1;
      }
    }

    .role-wrapper {
      margin-right: 20px;
      margin-left: 0;
    }

    .exit-wrapper {
      display: flex;
      align-items: center;
      font-weight: 400;
      color: #ffffff;
      font-size: 12px;
      margin-right: 25px;
      cursor: pointer;
      .user-avatar {
        width: 20px;
        height: 20px;
        margin-right: 11px;
      }
      span {
        line-height: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue